module.exports = __webpack_public_path__ + "static/img/12.920fb74.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/12.png
// module id = ID+S
// module chunks = 0